import gql from "graphql-tag";
import { LazyQueryHookOptions, useLazyQuery } from "@apollo/client";

import { SkillFragment, SKILL_FRAGMENT } from "../../fragments";
import { SkillsQueryVariables } from "../../types";

export const GET_SKILLS = gql`
  query getSkills(
    $q: String
    $locale: String
    $page: Int
    $per: Int
  ) {
    skills(
      q: $q
      locale: $locale
      page: $page
      per: $per
    ) {
      collection {
        ...SkillFragment
      }
    }
  }
  ${SKILL_FRAGMENT}
`;

export type SkillsData = { skills: { collection: SkillFragment[] } };

export default (
  options?: LazyQueryHookOptions<SkillsData, SkillsQueryVariables>
) => {
  return useLazyQuery<SkillsData, SkillsQueryVariables>(
    GET_SKILLS,
    options
  );
};
